import { UserDetails } from './shared.interface';

export enum PaymentsGridColumnType {
    Date,
    Status,
    Amount,
    Link,
    Generic,
    PaymentMode
}

export enum PaymentsHistoryGridColumnType {
    Status,
    Date,
    Generic
}

export interface GetPaymentRequestPayload extends SearchToken {}

export interface SearchToken {
    searchToken?: string;
}

/**
 * IMPORTANT NOTE: Any modification to below interface fields for UI grid columns should be
 * reflected in the following file:
 * fetchSearchedPaymentsList() method in shopper-details/payments/payments.service.ts
 */
export interface Payments {
    transactionId: string;
    payment_id: string;
    invoice_id: string;
    payment_date?: string;
    payment_status?: PaymentStatus;
    amount?: number;
    currency?: string;
    payment_mode?: string;
    email_id?: string;
    user_identifier?: string; // Not sent by BE currently
    payment_processor?: string; // Not sent by BE currently
    partner?: string; // Not sent by BE currently
    encryptedShopperToken?: string; // Instead of caching 50k entries each call, encrypt it for FE to supply back 1 at a time
    processed_payment_histories?: PaymentHistory[];
    userDetails?: UserDetails;
}

export interface PaymentHistory {
    invoice_status: string;
    created_at?: string;
    event_name?: string;
    event_description?: string;
}

export enum PaymentStatus {
    PAID = 'paid',
    WAITING = 'waiting',
    PENDING = 'pending',
    CANCELLED = 'cancelled',
    EXPIRED = 'expired',
    REVERSED = 'reversed',
    ERROR = 'error',
    SUCCESS = 'success',
    RETURNED = 'returned',
    ONHOLD = 'onhold',
    UNCLAIMED = 'unclaimed',
    UNDER_REVIEW = 'under_review',
    INCOMPLETE = 'incomplete',
    FAILED = 'failed'
}

export interface ReprocessPaymentUIRequestPayload extends SearchToken {
    invoiceId: string;
    paymentMode: ReprocessPaymentMode;
    paymentIdentifierType?: PreferredPaymentIdentifierType | string;
    paymentIdentifier: string;
    isPreferredPayout?: boolean;
}

export interface ReprocessPaymentResponsePayload {
    status: ReprocessPaymentAPIStatus;
    message?: string; // Only sent when status is SUCCESS
    error_code?: string; // Only sent when status is FAILED
    error_message?: string; // Only sent when status is FAILED
}

export enum ReprocessPaymentAPIStatus {
    SUCCESS = 'SUCCESS',
    FAILED = 'FAILED'
}

// Used by FE
export enum PaymentModeUI {
    PayPal = 'PayPal',
    Venmo = 'Venmo'
}

// Used by BE for both reprocess payment
export enum ReprocessPaymentMode {
    PayPal = 'PayPalID',
    Venmo = 'VenmoID'
}

// Used by BE for Get & Set preferred payout method
// Also sent by BE in dynamic partner payment config in partner picklist API
export enum PreferredPaymentMode {
    PayPal = 'PAYPAL',
    Venmo = 'VENMO'
}

// Dynamic partner payment config sent by BE in partner picklist API
export enum PreferredPaymentIdentifierType {
    Email = 'email',
    PhoneNumber = 'phonenumber'
}

export interface PreferredPaymentModePayload extends SearchToken {
    payment_mode?: string;
    identifier_type?: string;
    identifier_value?: string;
}
